var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('page-header',{attrs:{"title":_vm.$t('dictionary.log_manage')}}),_c('page-body',[_c('list',{attrs:{"id":_vm.listId,"logtype":_vm.actions,"apiver":_vm.v1,"service":_vm.log}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }